import { combineReducers } from '@reduxjs/toolkit';
import auth from './authSlice';
import common from './commonSlice';
import chatReducer from '../Pages/Chats/chat.slice';
import notification from './notification.slice';
import studio from './StudioSlice';
import production from './ProductionSlice';
import dashboard from './dashboardSlice';
import set from './setSlice';
import location from './locationSlice';
import episode from './episodeSlice';
import staticData from './staticContent.slice';
import riskCenter from './riskCenterSlice';
import store from './storeSlice';
import myDocument from './myDocument.Slice';
import spending from './spendingslice';
import schedularSlice from './schedularSlice';
import order from './orderSlice';
import cart from './cart.slice';
import orderList from './orderList.slice';
import ach from './achSlice';
import riskSecuritySlice from './riskSecuritySlice';

export const rootReducer = combineReducers({
  auth,
  common,
  studio,
  production,
  // commission,
  chat: chatReducer,
  dashboard,
  notification,
  set,
  episode,
  location,
  staticData,
  riskCenter,
  store,
  myDocument,
  spending,
  schedularSlice,
  order,
  cart,
  orderList,
  ach,
  riskSecuritySlice,
});
